import { types } from "mobx-state-tree";

const VideoQualityStore = types.model({
  name: types.maybeNull(types.string),
  url: types.maybeNull(types.string),
  type: types.maybeNull(types.string),
});

const TimelineStore = types.model({
  id: types.identifierNumber,
  checkpoint: types.maybeNull(types.integer),
  content: types.maybeNull(types.string),
});

export const VideoStore = types
  .model({
    name: types.maybeNull(types.string),
    status: types.maybeNull(types.string),
    duration: types.maybeNull(types.integer),

    thumbnail_url: types.maybeNull(types.string),
    url: types.maybeNull(types.string),
    video_url: types.maybeNull(types.string),
    qualities: types.maybeNull(types.array(VideoQualityStore)),

    timelines: types.array(TimelineStore),
  })
  .actions((self) => {
    const fillable = ["name", "status", "duration", "thumbnail_url", "url", "video_url"];

    const update = (newData) => {
      fillable.forEach((field) => {
        if (!!newData[field]) {
          self[field] = newData[field];
        }
      });
    };

    const addTimeline = (newTimestamp) => {
      self.timelines.push(newTimestamp);
    };

    const deleteTimeline = (id) => {
      self.timelines = self.timelines.filter((tl) => tl.id !== id);
    };

    return {
      update,

      addTimeline,
      deleteTimeline,
    };
  });
